var _ellipse, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendChatStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.2727,
    cy: 20,
    rx: 20.4545,
    ry: 20,
    fill: "#825DFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 13,
    width: 14,
    height: 14,
    rx: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendChatStop);
export default __webpack_public_path__ + "static/media/send_chat_stop.3638bcc1bb9619e0446b2256477a7d27.svg";
export { ForwardRef as ReactComponent };